import { render } from "./DeviceLora.vue?vue&type=template&id=497b6bb2&scoped=true&ts=true"
import script from "./DeviceLora.vue?vue&type=script&lang=ts"
export * from "./DeviceLora.vue?vue&type=script&lang=ts"

import "./DeviceLora.vue?vue&type=style&index=0&id=497b6bb2&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497b6bb2"]])

export default __exports__